import React from "react";
import { ToastContainer, toast as reactToast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const TRACKER_TOAST_CONTAINER_ID = "tracker-toast";

const withTrackerContainer = (options = {}) => ({
  ...(options || {}),
  containerId: TRACKER_TOAST_CONTAINER_ID,
});

export const trackerToast = {
  success: (content, options) => reactToast.success(content, withTrackerContainer(options)),
  error: (content, options) => reactToast.error(content, withTrackerContainer(options)),
  info: (content, options) => reactToast.info(content, withTrackerContainer(options)),
  warn: (content, options) => reactToast.warn(content, withTrackerContainer(options)),
  warning: (content, options) =>
    (reactToast.warning || reactToast.warn)(content, withTrackerContainer(options)),
};

export const TrackerToastContainer = () => (
  <ToastContainer
    containerId={TRACKER_TOAST_CONTAINER_ID}
    position="top-right"
    autoClose={3500}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
  />
);
